import { BsArrowBarLeft } from "react-icons/bs";
import "./pagination.css";

export default function Pagination({ page, totalPages, onPageChange, limit, onLimitChange, limitOptions = [1, 5, 10, 20, 50, 100] }) {
  // helper to render page buttons (you can tweak start/end or show “…” if too many)
  /*   const pages = Array.from({ length: totalPages }, (_, i) => i + 1); */
  // Build truncated page list
  const pageList = [];

  if (totalPages <= 5) {
    // Show all pages if 5 or fewer
    for (let i = 1; i <= totalPages; i++) pageList.push(i);
  } else {
    // Always show first page
    pageList.push(1);

    // Determine window of pages around current
    const start = Math.max(2, page - 1);
    const end = Math.min(totalPages - 1, page + 1);

    // Add leading ellipsis if needed
    if (start > 2) {
      pageList.push("start-ellipsis");
    }

    // Add pages around current
    for (let i = start; i <= end; i++) pageList.push(i);

    // Add trailing ellipsis if needed
    if (end < totalPages - 1) {
      pageList.push("end-ellipsis");
    }

    // Always show last page
    pageList.push(totalPages);
  }

  return (
    <div className='paginationTab'>
      <div className='paginationControls'>
        <button onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
          <BsArrowBarLeft size={20} style={{ marginRight: "0.2rem" }} />
          Prev
        </button>

        {pageList.map((p, idx) =>
          p === "start-ellipsis" || p === "end-ellipsis" ? (
            <span key={`ellipsis-${idx}`}>…</span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              style={{
                fontWeight: p === page ? "bold" : "normal",
                textDecoration: p === page ? "underline" : "none",
              }}
            >
              {p}
            </button>
          )
        )}

        <button onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>
          Next
          <BsArrowBarLeft size={20} style={{ marginLeft: "0.2rem", transform: "rotate(180deg)" }} />
        </button>
      </div>

      <div className='paginationLimit'>
        <label style={{ marginLeft: "1rem" }}>
          Show rows per page:{" "}
          <select
            value={limit}
            onChange={(e) => {
              onLimitChange(Number(e.target.value));
            }}
          >
            {limitOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
}
